import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MyAccountComponent } from "../widgets/my-account/my-account.component";
import { TopbarComponent } from "../widgets/topbar/topbar.component";
import { RouterModule } from "@angular/router";
import { CartComponent } from "../widgets/cart/cart.component";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { AuthState } from "src/app/core/auth/state/auth.state";
import { DsNavbarComponent, DsNavbarItem } from "src/app/ui/design-system/navbar/navbar.component";

@Component({
  standalone: true,
    selector: "app-basic-header",
    templateUrl: "./basic-header.component.html",
    styleUrls: ["./basic-header.component.scss"],
    imports: [
        CommonModule,
        TranslateModule,
        MyAccountComponent,
        TopbarComponent,
        RouterModule,
        CartComponent,
        DsNavbarComponent]
})
export class BasicHeaderComponent implements AfterViewInit {
  @ViewChild("headerRoot", { static: true }) headerRef!: ElementRef<HTMLElement>;
  @ViewChild("stickyHeader", { static: true }) stickyHeaderRef!: ElementRef<HTMLElement>;
  @Select(AuthState.isAuthenticated) isAuthenticated$!: Observable<boolean>;
  stick = false;
  active = false;
  private readonly stickOnOffset = 53;
  private readonly stickOffOffset = 20;

  constructor(private readonly translate: TranslateService) {}

  getQuickLinkItems(isAuthenticated: boolean): DsNavbarItem[] {
    const links: DsNavbarItem[] = [
      {
        label: this.translate.instant("auto_inicio"),
        route: "/home",
        exact: true},
      {
        label: this.translate.instant("streamer_breadcrumb"),
        route: "/creators"}];

    if (!isAuthenticated) {
      links.push({
        label: this.translate.instant("auto_registrar"),
        route: "/auth/creator-register"});
    }

    return links;
  }

  ngAfterViewInit() {
    this.updateStickyHeight();
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.updateStickyHeight();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (window.innerWidth <= 400) {
      this.stick = false;
      return;
    }

    if (!this.stick && number >= this.stickOnOffset) {
      this.stick = true;
      return;
    }

    if (this.stick && number <= this.stickOffOffset) {
      this.stick = false;
    }
  }

  toggle(val: boolean) {
    this.active = val;
  }

  private updateStickyHeight() {
    if (!this.headerRef || !this.stickyHeaderRef) {
      return;
    }

    const height = this.stickyHeaderRef.nativeElement.offsetHeight;
    this.headerRef.nativeElement.style.setProperty("--sticky-height", `${height}px`);
  }
}
